import React, { Component } from 'react'
import Menu from './includes/Menu'
import { Grid } from '../../../node_modules/@material-ui/core';
import BusinessPrecMetalsChart from '../assets/images/business-prec-metals-chart.png';
import BusinessPrecMetalsChartSC from '../assets/images/business-prec-metals-chart-sc.png';
import BusinessPrecMetalsChartEN from '../assets/images/business-prec-metals-chart-en.png';

const lang = '';

class BusinessPreciousMetals extends Component {
  constructor(props) {
    super(props);
    this.lang = (props.lang) ? props.lang : '';
  }

  componentDidMount() {
    document.title = this.getLangText({
      'tc': '貴金屬',
      'sc': '贵金属',
      'en': 'Precious Metals'
    });
  }

  getLangText(langJson) {
    return (this.lang) ? langJson[this.lang] : langJson['tc'];
  }

  render(){
    return(
      BusinessPreciousMetalsJSX(this)
    );
  }
}

const BusinessPreciousMetalsJSX = (ctx) => (
  <div className={ (ctx.lang === 'en' ? 'en' : '') }>
    <Menu lang={ ctx.lang } />
  
    <div className='main-content-container'>
      <div className='main-content-inner-wrapper business'>
        <Grid container spacing={0}>
          <Grid item id='page-title'>
            <span>
              {
                ctx.getLangText({
                    'tc': '貴金屬',
                    'sc': '贵金属',
                    'en': 'Precious Metals'
                })
              }
            </span>
          </Grid>
        </Grid>
        <div style={{clear:'both'}}></div>

        <div className='business-container'>
          <Grid container spacing={0} className='content-container'>
            <Grid item style={{paddingBottom:'30px'}}>
              <p>
                <a className="theme-color" href="https://www.91pme.com/tc/" target="_blank" alt="香港鑫匯寶貴金屬有限公司">
                  {
                    ctx.getLangText({
                        'tc': '香港鑫匯寶貴金屬有限公司',
                        'sc': '香港鑫汇宝贵金属有限公司',
                        'en': 'Hong Kong Xinhuibao Precious Metals Co., Ltd.'
                    })
                  }
                </a>&nbsp;
                {
                  ctx.getLangText({
                      'tc': '是香港金銀業貿易場106號行員，持有AA類別(最高類)市場交易有效營業牌照，可經營的交易品種包括倫敦金/銀、99金、港元公斤條、、人民幣公斤條、港元999.9黃金等。',
                      'sc': '是香港金银业贸易场106号行员，持有AA类别(最高类)市场交易有效营业牌照，可经营的交易品种包括99金、港元公斤条、伦敦金/银、人民币公斤条、港元999.9黄金等。',
                      'en': 'is a member of The Chinese Gold & Silver Exchange Society (membership no.: 106) and holds an AA type (highest) of market trading license,  specializing in trading LLG, LLS,  99 Tael Gold, Renminbi Kilobar Gold, HKD Kilo Gold, 999.9 Tael Gold etc.'
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                      'tc': '鑫匯寶貴金屬遵守貿易場嚴格規範及監管。公司提供交易編碼供核實成交記錄、歷史分筆報價數據查詢等服務，使交易透明度大幅提升。客戶資金完全獨立存管於專屬銀行托管戶口，確保不被挪用。',
                      'sc': '鑫汇宝贵金属遵守贸易场严格规范及监管。公司提供交易编码供核实成交记录、历史分笔报价数据查询等服务，使交易透明度大幅提升。客户资金完全独立存管于专属银行托管户口，确保不被挪用。',
                      'en': `As a regulated member of The Chinese Gold & Silver Exchange Society, Xinhuibao Precious Metals complies with the rules and is subject to the supervision of the Society. We provide transaction codes for verification of trading records, historical data feed etc., greatly increasing transaction transparency. Clients' capitals are fully and independently saved and managed in exclusive custodian bank accounts to avoid misappropriation.`
                  })
                }
              </p>
            </Grid>

            <div className='business-chart'>
              <span className='business-adv-text'>
                {
                  ctx.getLangText({
                      'tc': '優勢',
                      'sc': '优势',
                      'en': 'Advantages'
                  })
                }
              </span>

              <Grid container spacing={0} justify='center' style={{padding:'20px'}}>
                <Grid item>
                 <img id='img-business-chart' style={{ display:'inline-block', verticalAlign:'middle', width:'100%'}}
                       src={ctx.getLangText({
                                              'tc': BusinessPrecMetalsChart,
                                              'sc': BusinessPrecMetalsChartSC,
                                              'en': BusinessPrecMetalsChartEN
                                              })
                                            } />
                </Grid>
              </Grid>
            </div>

          </Grid>
        </div>
      </div>
    </div>
  </div>
)

export default BusinessPreciousMetals



// WEBPACK FOOTER //
// ./src/components/pages/PreciousMetals.js